export type AttrInitCallBack = { attrName: string, attrValue: string, obj: any };